import { LinkKind } from 'bloko/blocks/link';

export default [
    {
        url: 'https://hh.ru/article/services',
        anchor: 'footer.employerLinks.services',
        kind: LinkKind.Tertiary,
    },
    {
        url: 'https://hh.ru/demo',
        anchor: 'footer.employerLinks.demo',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/calendar',
        anchor: 'footer.employerLinks.calendar',
        kind: LinkKind.Secondary,
    },
    {
        url: 'https://hh.ru/article/hrdigital?from=footer',
        anchor: 'footer.employerLinks.hrDigital',
        kind: LinkKind.Secondary,
    },
];
